import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor() { }

  getDeviceGroups(): Observable<any[]> {
    // Replace with actual data fetching logic
    const mockData = [
      {
        groupName: 'Group 1',
        items: [
          { 
            name: 'Device 1', 
            dongleUId: 'D123', 
            controllerTypeName: 'Model A', 
            ownerName: 'John Doe', 
            softwareVersion: '1.0' 
          },
          { 
            name: 'Device 2', 
            dongleUId: 'D456', 
            controllerTypeName: 'Model B', 
            ownerName: 'Jane Smith', 
            softwareVersion: '1.2' 
          }
        ]
      },
      {
        groupName: 'Group 2',
        items: [
          { 
            name: 'Device 3', 
            dongleUId: 'D789', 
            controllerTypeName: 'Model C', 
            ownerName: 'Peter Jones', 
            softwareVersion: '2.0' 
          }
        ]
      }
    ];
    return of(mockData);
  }
}
